import React, {Component} from 'react';

import ScheduleEFForm from './ScheduleEFForm'
import ScheduleEFView from './ScheduleEFView'
import LoadingBar from "../components/Modules/LoadingBar";

import PropTypes from 'prop-types';

class ScheduleEF extends Component {
  static propTypes = {
    canEdit:        PropTypes.bool,
    loading:        PropTypes.bool,
    onSaveSchedule: PropTypes.func.isRequired,
    schedule_ef:    PropTypes.object,
  }

  constructor(props) {
    super(props);
    this.state = {
      editing: false,
    };
  }

  render() {
    if (this.props.loading) return <LoadingBar/>;

    if ( ! this.props.canEdit)
      return <ScheduleEFView schedule_ef={ this.props.schedule_ef } />;

    if ( ! this.state.editing )
      return <div>
        <ScheduleEFView schedule_ef={ this.props.schedule_ef } />
        { this.props.canEdit &&
            <a style={{float:'right', color: 'blue'}}
               onClick={() => this.setState({editing: true })}>Edit</a>
        }
      </div>
    else
      return <ScheduleEFForm
        data={ this.props.schedule_ef.data }
        onSubmit={ this.props.onSaveSchedule }
        onCancel={ () => this.setState({ editing: false }) }
      />

  }

}


export default ScheduleEF;



/** WEBPACK FOOTER **
 ** ./src/scheduleform/ScheduleEF.jsx
 **/